<template>
    <PageFrameContainer>
        <div class="cart-container">
            <h2>
                {{$t('pages.cart.title')}}
            </h2>
            <div class="products-table">
                <p class="header product-name-header">{{$t('pages.cart.cartTable.productName')}}</p>
                <p class="header">{{$t('pages.cart.cartTable.quantity')}}</p>
                <p class="header costPerMonth">{{$t('pages.cart.cartTable.costPerMonth')}}</p>
                <p class="header">{{$t('pages.cart.cartTable.annualPlan')}}</p>
                <p class="header last">{{$t('pages.cart.cartTable.total')}}</p>
                <template v-for="product in Object.keys(cart)">
                    <div class="versions-track" :key="`${product}-track`"></div>
                    <router-link :to="{ name: resolveLink(product), params: {productId: product} }" class="product-name"
                                 :key="`${product}-link`">
                        <img :key="`${product}-img`" class="logo" :src="getImagePath(product)" :alt="product">
                    </router-link>
                    <router-link :to="{ name: resolveLink(product), params: {productId: product} }" class="product-name"
                                 :key="product">{{product|productLicenseTypeFilterWithKey}}
                    </router-link>
                    <div class="quantity-block" :key="`${product}-qty`">
                        <button class="quantity-minus" v-on:click="decQty(product)">
                            -
                        </button>
                        <input class="quantity-num" type="number" :value="cart[product]"
                               min="1"
                               max="99999"
                               @change="onQtyChanged($event,product)"/>
                        <button class="quantity-plus" v-on:click="incQty(product)">+</button>
                        <button class="quantity-cancel" v-on:click="cancelQty(product)">X</button>
                    </div>
                    <p :key="`${product}-monthPrice`" class="costPerMonth">$ {{pricePerMonthPerUnit(product)}}</p>
                    <p :key="`${product}-price`">$ {{pricePerUnit(product)}}</p>
                    <p class="last" :key="`${product}-total`">$ {{totalUnitsPrice(product,cart[product])}}</p>
                </template>
            </div>
            <div class="total-table">
                <p>{{$t('pages.cart.subTotal')}}:</p>
                <p>$ {{subTotalPrice()}}</p>
                <div class="versions-track"></div>
                <p class="total">{{$t('pages.cart.cartTable.total')}}:</p>
                <p class="total">$ {{totalPrice()}}</p>
            </div>

            <a :href="getCheckoutRef()" v-if="totalPrice()>0" class="checkout">
                {{$t('pages.cart.checkout')}}
            </a>

            <button class="checkout-not-active" v-else>
                {{$t('pages.cart.checkout')}}
            </button>
        </div>
    </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "../../components/PageFrameContainer";

    export default {
        name: "CartPage",
        components: {PageFrameContainer},
        props: [],
        data: function () {
            return {
                qty: {}
            }
        },
        mounted: function () {

        },
        computed: {
            cart() {
                return this.$store.state.cart;
            }
        },
        methods: {
            pricePerUnit(_product) {
                return this.$prices.getProductPrice(_product, 'annualy');
            },
            pricePerMonthPerUnit(_product) {
                return this.$prices.getProductPrice(_product, 'perMonth');
            },
            totalUnitsPrice(_product, _qty) {
                return _qty * this.pricePerUnit(_product);
            },
            onQtyChanged(_event, _product) {
                this.$store.commit('setToCart', {product: _product, qty: +_event.target.value});
            },
            decQty(_product) {
                this.$store.commit('addToCart', {product: _product, qty: -1});
            },
            incQty(_product) {
                this.$store.commit('addToCart', {product: _product, qty: +1});
            },
            cancelQty(_product) {
                this.$store.commit('setToCart', {product: _product, qty: -1});
            },
            subTotalPrice() {
                return this.totalPrice();
            },
            totalPrice() {
                let cart = this.$store.state.cart;
                let products = Object.keys(cart);
                let totalQty = 0;
                for (let x of products)
                    totalQty += cart[x] * this.pricePerUnit(x);
                return totalQty;
            },
            getImagePath(_product) {
                switch (_product) {
                    case 'BW1Start':
                        return require(`../../assets/icons/logo_start.svg`);
                    case 'BW1Standard':
                        return require(`../../assets/icons/logo_standard.svg`);
                    case 'BW1Power':
                        return require(`../../assets/icons/logo_power.svg`);
                }
                return require(`../../assets/icons/logo_onebw.svg`);
            },
            resolveLink(_product) {
                switch (_product.toLowerCase()) {
                    case 'bw1start':
                        return 'pricingStart';
                    case 'bw1standard':
                        return 'pricingStandard';
                    case 'bw1power':
                        return 'pricingPower';
                }
            },
            getInputValue() {
                return (this.totalPrice() > 0)
            },
            getCheckoutRef() {
                let cart = this.$store.state.cart;
                let products = Object.keys(cart);
                let checkoutProducts = [];
                let qtys = [];
                const productTo2CheckoutId = {
                    "BW1Start":30082916,
                    "BW1Standard":30079414,
                    "BW1Power":30079418
                };

                for (let product of products) {
                    if(!Object.prototype.hasOwnProperty.call(productTo2CheckoutId,product))
                        continue;
                    checkoutProducts.push(productTo2CheckoutId[product]);
                    qtys.push(cart[product]);
                }
                return `https://secure.2checkout.com/order/checkout.php?CLEAN_CART=1&PRODS=${checkoutProducts}&CURRENCY=USD&QTY=${qtys}&SHOPURL=http%3A//www.oneblending.com${this.$router.resolve('cart').href}&BACK_REF=http%3A//www.oneblending.com${this.$router.resolve('clean-cart').href}`;
            }


        }

    }
</script>

<style scoped lang="scss">
    @import "../../theme/theme";

    h2 {
        font-weight: 300;
        font-size: 2em;
        color: $primary20;
    }

    .cart-container {
        display: grid;
        row-gap: 2rem;
        margin-top: 2rem;

        .products-table {
            display: grid;
            grid-template-columns: 8rem repeat(5, auto);
            border: 1px solid $text40;
            border-radius: 0.3rem;
            row-gap: 0.5rem;

            h4 {
                text-align: center;
                justify-self: center;
            }

            p {
                text-align: center;
                font-weight: 300;
                font-size: 1.3rem;
                align-self: center;
                justify-self: center;
                padding-bottom: 1rem;
                padding-top: 1rem;
                margin-right: 0.2rem;
            }

            p.costPerMonth {
                color: $text60;
            }

            p.last {
                margin-right: 1rem;
            }

            .product-name {
                font-weight: 400;
                font-size: 1.2rem;
                color: $primary20;
                align-self: center;
                justify-self: center;
            }

            .header {
                font-weight: 400;
                grid-row: 1;
                font-size: 1rem;
            }

            .product-name-header {
                grid-column: 1/span 2;
                align-self: center;
                justify-self: center;
            }

            img {
                justify-self: center;
                max-height: 7rem;
            }

            .versions-track {
                margin-bottom: 0;
                border-bottom: 1px solid $text20;
                z-index: -1;
                grid-column: 1/-1;
            }


            //************************
            //quantity-block
            //************************
            input[type="number"]::-webkit-outer-spin-button,
            input::-webkit-inner-spin-button {
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                // margin: 0;
            }

            input[type="number"] {
                -moz-appearance: textfield;
                border: 1px solid $back100;
                margin-left: 0.2rem;
                margin-right: 0.2rem;
            }


            .quantity-block {
                margin: auto;
                font-size: 1rem;
                display: grid;
                grid-template-columns: auto auto auto auto;
                grid-template-rows: auto;
            }

            button {
                user-select: none;
                cursor: pointer;
                font-size: 1.1rem;
                padding: 5px 22px;
                text-decoration: none;
                border-radius: 0.9em;
                border-width: 1px;
                border-color: $primary20;
                text-effect: none;
                margin-right: 0.1rem;
                border-style: solid;
                transition: all .25s;
                background: $text10;
                color: $primary20;
                outline: none;
            }

            button:hover {
                background: $primary100;
                transition-duration: .25s;
                color: $primaryText100;
            }

            button:focus {
                // border-width: 2px;
                border-color: $primary80;
            }

            .quantity-cancel {
                border-radius: 0.9em;
                margin-left: 1em;
                font-size: 0.8rem;
                background: $primary20;
                color: $primaryText100;

            }

            .quantity-cancel:hover {
                background: $primary100;
            }

            .quantity-num {
                font-size: 1.3rem;
                padding: 5px 10px;
                border-radius: 4px;
                width: 4rem;
                height: 2rem;
                outline: none;
                text-align: center;

            }

            a {
                text-decoration: none;
                text-effect: none;
                font-size: 1.3em;
                color: $primary20;
                text-align: center;
                margin-left: 1rem;
                margin-right: 1rem;
            }

            a:hover {
                color: $primary80;
            }

            a img:hover {
                opacity: 0.7;
            }
        }

        .total-table {
            display: grid;
            grid-template-columns: auto auto;
            grid-template-rows: auto auto;
            justify-self: end;
            column-gap: 2rem;
            border: 1px solid $text20;
            border-radius: 0.2rem;
            margin-top: 2rem;

            p {
                border-right: 1px solid $text20;
                padding-right: 2rem;
                padding-left: 0.5rem;
                height: 2rem;
                padding-top: 0.4rem;
                font-size: 1.2rem;
            }

            .total {
                font-size: 1.4rem;
                font-weight: 400;
            }

            .versions-track {
                margin-bottom: 0;
                border-bottom: 1px solid $text20;
                z-index: -1;
                grid-column: 1/-1;
            }
        }

        a.checkout {
            padding: 0.7em 2em;
            background: $primary20;
            border: 0;
            text-decoration: none;
            border-radius: 0.4rem;
            text-effect: none;
            font-size: 1em;
            align-self: center;
            justify-self: end;
            cursor: pointer;
            color: $primaryText100;
            transition: all .25s;
            margin-bottom: 2rem;
            outline: none;
        }

        a.checkout:hover {
            background: $primary100;
        }


        button.checkout-not-active {
            padding: 0.7em 2em;
            background: $primary30;
            border: 0;
            text-decoration: none;
            border-radius: 0.4rem;
            text-effect: none;
            font-size: 1em;
            align-self: center;
            justify-self: end;
            cursor: pointer;
            color: $primaryText100;
            transition: all .25s;
            margin-bottom: 2rem;
            outline: none;
        }
    }
</style>